import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ReqResService } from '../../service/req-res.service';
declare var $: any;
declare var toastr: any;
@Component({
  selector: 'app-webform',
  templateUrl: './webform.component.html',
  styleUrls: ['./webform.component.css']
})
export class WebformComponent implements OnInit {
  webFormData: any = {};
  spinner: boolean = false;
  searchAssigner: string = "";
  constructor(private reqRes: ReqResService
    , private titleService: Title) {
    this.titleService.setTitle('Web Form'); }


  ngOnInit(): void {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    this.getWebFormInfo();
  }


  saveWebFormInfo() {
    this.spinner = true;
    this.reqRes.postData('/Settings/SaveWebForm', this.webFormData).subscribe(data => {
      this.spinner = false;
      toastr.success('Done!', '', { timeOut: 1000 });
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }



  changeWebFormOpe(val,ope) {
    if (ope == 'emailOpe') {
     this.webFormData.emailReqOpe = val;
    }
   else if (ope == 'phoneOpe') {
        this.webFormData.phoneReqOpe = val;
    }
    else if (ope == 'streetOpe') {
      this.webFormData.streetReqOpe = val;
    }
    else if (ope == 'cityOpe') {
      this.webFormData.cityReqOpe = val;
    }
    else if (ope == 'stateOpe') {
      this.webFormData.stateReqOpe = val;
    }
    else if (ope == 'zipOpe') {
      this.webFormData.zipReqOpe = val;
    }
    else if (ope == 'typeOpe') {
      this.webFormData.typeReqOpe = val;
    }
    else if (ope == 'descOpe') {
      this.webFormData.descReqOpe = val;
    }
    else if (ope == 'fileOpe') {
      this.webFormData.fileReqOpe = val;
    }
  }

  getWebFormInfo() {
    this.reqRes.getData('/Settings/GetSettingsEditData/0/webForm').subscribe(data => {
      this.webFormData = data;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
 assignerChange(index, obj, ope) {
    if (ope == "add") {
      this.webFormData.assigner.push(obj);
      let _index = this.webFormData.assignerList.findIndex(item => item.id == obj.id);
      this.webFormData.assignerList.splice(_index, 1);
    }
    else if (ope == "remove") {
      this.webFormData.assignerList.push(obj);
      this.webFormData.assigner.splice(index, 1);
      $("[data-toggle='tooltip']").tooltip('hide');
    }
   this.searchAssigner = '';
 }

  copyStringToClipboard(str) {
    navigator.clipboard.writeText(str);
    toastr.success('Copied succesfully!', '', { timeOut: 1000 });
  }
}
